module.exports = __webpack_public_path__ + "static/img/200222.0b977f07.png";